import {RefObject, useEffect} from 'react';

const useClickOutside = <T extends HTMLElement>(ref: RefObject<T>, fn: () => void) => {
  useEffect(() => {
    const element = ref?.current;
    function handleClickOutside(event: Event) {
      //   console.log(event, element);
      if (element && !element.contains(event.target as Node | null)) {
        fn();
      }
    }
    document.addEventListener('click', handleClickOutside);
    // document.addEventListener('contextmenu', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    //   document.removeEventListener('contextmenu', handleClickOutside);
    };
  }, [ref, fn]);
};

export default useClickOutside;
